var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLaneKeepAssist24 = function SvgLaneKeepAssist24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.089 5h1.822c.82 0 1.605.31 2.184.862.58.551.905 1.3.905 2.08v8.587a2.41 2.41 0 0 1-.76 1.747 2.661 2.661 0 0 1-1.834.724h-2.812c-.34 0-.678-.064-.993-.188a2.608 2.608 0 0 1-.841-.536 2.466 2.466 0 0 1-.563-.801A2.37 2.37 0 0 1 8 16.529V7.942c0-.78.325-1.529.905-2.08A3.169 3.169 0 0 1 11.089 5v0Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.966 9h2.046c.792 0 1.552.26 2.113.725.56.464.875 1.094.875 1.75v2.85c0 .179-.086.35-.239.477a.908.908 0 0 1-.576.198h-6.37a.908.908 0 0 1-.576-.198.623.623 0 0 1-.239-.477v-2.858c.003-.652.316-1.277.871-1.739.556-.462 1.309-.723 2.095-.728v0ZM8 11H6m12 0h-2M2 2v20M22 2v20",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgLaneKeepAssist24;